import { getAddressString } from "@msuite/utils/strings";
import { View } from "@react-pdf/renderer";
import React from "react";
import {
	COMPANY_INFORMATION_BOTTOM_PADDING,
	COMPANY_INFORMATION_MIN_HEIGHT,
	COMPANY_INFORMATION_WIDTH,
} from "../_defaults";
import { useDocumentContext } from "../context";
import { tw } from "../tailwind";
import { Text } from "../text";

export function CompanyInformation() {
	/** Context */
	const context = useDocumentContext();

	/** Render */
	return (
		<React.Fragment>
			<View
				style={{
					flex: 1,
					flexDirection: "row",
					justifyContent: "flex-end",
					minHeight: `${COMPANY_INFORMATION_MIN_HEIGHT}px`,
					paddingBottom: `${COMPANY_INFORMATION_BOTTOM_PADDING}px`,
				}}
			>
				<View
					style={{
						width: `${COMPANY_INFORMATION_WIDTH}px`,
						flexDirection: "column",
					}}
					fixed
				>
					<Text style={tw("text-xs mb-2 underline")}>
						{context.workspaceMetadata?.companyName} - {getAddressString(context.workspaceMetadata)}
					</Text>
					{context.workspaceMetadata?.phone && (
						<Text style={tw("text-xs")}>Tel: {context.workspaceMetadata.phone}</Text>
					)}
					{context.workspaceMetadata?.email && (
						<Text style={tw("text-xs")}>Mail: {context.workspaceMetadata.email}</Text>
					)}
					{context.workspaceMetadata?.web && (
						<Text style={tw("text-xs")}>Web: {context.workspaceMetadata.web}</Text>
					)}
				</View>
			</View>
		</React.Fragment>
	);
}
